const PRODUCT_NAME = 'Jira Software';

export type Props = {
	onDismissed: (messageInstanceId: string) => void;
};

export const Recommendation = ({ onDismissed }: Props) => (
	<button onClick={() => onDismissed('SOME_MESSAGE_INSTANCE')}>{PRODUCT_NAME}</button>
);

export const render = Recommendation;
export default Recommendation;
